import { useCallback } from 'react';
import { useStoreState } from '~/store';
import useExpandedRows from '../useExpandedRows';
import { ColumnFactory } from '../../columns';
import { useProducts } from '~/hooks/useProducts';
export * from './context';

export default function useTable<
  C extends Parameters<typeof ColumnFactory.make>[1],
>(
  columnTree: C,
  orders,
  sortColumn: string,
  sortDirection: string,
  setSortColumn: (column: string) => void,
  setSortDirection: (direction: string) => void
) {
  const solution = useStoreState(state => state.auth.solution);
  const solutionSettings = useStoreState(state => state.auth.solutionSettings);
  const solutionColumns = useStoreState(state => state.auth.solutionColumns);
  const isSolutionOwner = useStoreState(state => state.auth.isSolutionOwner);
  const solutionDivisionIds = useStoreState(
    store => store.auth.solutionDivisionIds
  );

  const { data: products } = useProducts(solution?.id);
  const productById = (id: string) => products?.find(p => p.id === id);

  const expandedRows = useExpandedRows(orders);

  const setSort = useCallback(
    columnKey => {
      if (columnKey === sortColumn) {
        setSortDirection(sortDirection === 'down' ? 'up' : 'down');
      } else {
        setSortColumn(columnKey);
        setSortDirection('down');
      }
    },
    [sortDirection, sortColumn, setSortColumn, setSortDirection]
  );

  const context = {
    solution,
    solutionSettings,
    productById,
    setSort,
    solutionDivisionIds,
    sortColumn,
    sortDirection,
    solutionColumns,
    isSolutionOwner,
    ...expandedRows,
  };

  return {
    ...context,
    columns: ColumnFactory.make(context, columnTree),
  } as const;
}
